import { render, staticRenderFns } from "./HostingDomainsTable.vue?vue&type=template&id=539e22d0&scoped=true"
import script from "./HostingDomainsTable.vue?vue&type=script&lang=js"
export * from "./HostingDomainsTable.vue?vue&type=script&lang=js"
import style0 from "./HostingDomainsTable.vue?vue&type=style&index=0&id=539e22d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e22d0",
  null
  
)

export default component.exports